import { useState } from "react";

import { Project } from "interfaces";

import Tag from "ui-components/Tag";
import { useFetchColumnProfile } from "modules/data-files/api";

import * as flowConfig from "flows/network-failure-analysis/config";
import {
  projectIsNetworkFailureAnalysis,
  NetworkFailureAnalysisProject,
} from "flows/network-failure-analysis/interfaces";

const ContextSummary = ({
  project,
  hideModelTag,
}: {
  project: NetworkFailureAnalysisProject;
  hideModelTag: boolean;
}) => {
  const perfFile = project.data_files[flowConfig.PERFORMANCE_DATA];
  const { data: cellProfile, status } = useFetchColumnProfile(
    perfFile,
    flowConfig.PERF_CELL_NAME,
    "char"
  );
  const wsId = project.workspaces[0]?.workspace;
  const [showCells, setShowCells] = useState(false);
  return (
    <div className="m-1">
      {status === "success" && cellProfile && (
        <>
          <p>
            Data has {cellProfile.stats["unique-count"]} cells.{" "}
            {showCells ? (
              <span
                className="text-primary-main cursor-pointer"
                onClick={() => setShowCells(false)}
              >
                HIDE CELLS
              </span>
            ) : (
              <span
                className="text-primary-main cursor-pointer"
                onClick={() => setShowCells(true)}
              >
                SHOW CELLS
              </span>
            )}
          </p>
          {showCells && (
            <p className="px-2">
              Cells in Data:{" "}
              <span className="italic">
                {cellProfile.stats["unique-values"].join(", ")}
              </span>
            </p>
          )}
        </>
      )}
      <p>
        Success: <span className="underline">{flowConfig.CSSR}</span> Greater
        Than {flowConfig.THRESHOLD}
      </p>
      <p>
        Time Stamp Column: {project.meta_data[flowConfig.TIME_COLUMN_KEY][0]}
      </p>
      {wsId && !hideModelTag && (
        <div className="flex flex-wrap">
          <Tag bgColorClass="bg-primary-main" textColorClass="text-gray-100">
            Model Built
          </Tag>
        </div>
      )}
    </div>
  );
};

const Wrapper = ({
  project,
  hideModelTag,
}: {
  project: Project;
  hideModelTag?: boolean;
}) => {
  if (!projectIsNetworkFailureAnalysis(project)) {
    return null;
  }

  return <ContextSummary project={project} hideModelTag={hideModelTag} />;
};

export default Wrapper;
